/** Resolve the Turnstile site key (build-time Vite env wins over runtime health). */
export function resolveTurnstileSiteKey(buildTimeKey: string, runtimeKey: string): string {
	return (buildTimeKey.trim() || runtimeKey.trim()).trim();
}

/** Whether anonymous create should require a Turnstile token on the client. */
export function isCreateRoomTurnstileRequired(
	buildTimeKey: string,
	serverRequired: boolean | null,
): boolean {
	return buildTimeKey.trim().length > 0 || serverRequired === true;
}

/** Server requires verification but no site key is available to mount the widget. */
export function isTurnstileMisconfigured(turnstileRequired: boolean, effectiveSiteKey: string): boolean {
	return turnstileRequired && effectiveSiteKey.trim().length === 0;
}

export type HealthTurnstileFields = {
	createRoomTurnstile?: unknown;
	turnstileSiteKey?: unknown;
};

export function parseHealthTurnstileFields(data: unknown): {
	serverRequired: boolean | null;
	runtimeSiteKey: string;
} {
	if (!data || typeof data !== "object") {
		return { serverRequired: null, runtimeSiteKey: "" };
	}
	const row = data as HealthTurnstileFields;
	const serverRequired = typeof row.createRoomTurnstile === "boolean" ? row.createRoomTurnstile : null;
	const runtimeSiteKey = typeof row.turnstileSiteKey === "string" ? row.turnstileSiteKey.trim() : "";
	return { serverRequired, runtimeSiteKey };
}
